import { differenceInCalendarDays } from 'date-fns';

export const dayNumber = (first: Date, today: Date): number => differenceInCalendarDays(today, first) + 1;
